import React, { useState } from "react";
import { useIntl } from "@ai360/core/intl";

import {
    toSelectableCropDropdownOptions,
    useCropList,
    useCompanyCropScope,
} from "~/utils/crops/use-crop-list";
import {
    stampCropPurposeSelectable,
    toCropPurposeDropdownOptions,
    useCropPurposeList,
} from "~/utils/crops/use-crop-purpose-list";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, dropdowns, service, model } from "./../data";

const ConnectedAddEditPanel = AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    dropdowns,
    service,
});

const AddEditContainer = (props) => {
    const { formatMessage } = useIntl();
    const cropScope = useCompanyCropScope();
    const { crops } = useCropList({ scope: cropScope });
    const [cropGuid, setCropGuid] = useState(null);
    const { cropPurposes } = useCropPurposeList({ cropGuid, scope: cropScope });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{
                [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops, formatMessage),
                [model.PROPS_CROP_PURPOSE_LIST]: stampCropPurposeSelectable(
                    toCropPurposeDropdownOptions(cropPurposes),
                    formatMessage
                ),
                onCropGuidChange: setCropGuid,
            }}
        />
    );
};

export default AddEditContainer;
